// extracted by css-extract-rspack-plugin
export default {"input":"LabeledCurrencyInput_input__j+X7O"};